export default class CustomerType {
  constructor(id, desc) {
    this.desc = desc;
    this.id = id;
  }

  getName() {
    return this.desc;
  }

  getId() {
    return this.id;
  }
}

CustomerType.DIRECT = new CustomerType(1, '直客');
CustomerType.SUB = new CustomerType(2, '子客');
CustomerType.AGENCY = new CustomerType(3, '服务商');

Object.freeze(CustomerType);
